// YERİ: src/app/domains/website/sections/mkt-trial-hint.ts
//
// "N gün ücretsiz deneyin" — kayıt / "Hemen başlayın" düğmelerinin yanında
// küçük, AYRI bir ibare. CMS metinlerine dokunmaz; metni kod sözlüğünden
// (MktChromeText) gelir. Yalnız NİYET taşır: kayda götürür, uygunluk
// kurulumda (fatura adresinden sonra) çözülür. Genel teklif yoksa hiç çizilmez.

import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { MktChromeText } from '../core/mkt-chrome-text';
import { PublicTrialStore } from '../core/public-trial.store';

@Component({
  selector: 'mkt-trial-hint',
  standalone: true,
  imports: [RouterLink],
  host: { class: 'contents' },
  template: `
    @if (text(); as txt) {
      <a routerLink="/auth/sign-up"
        class="inline-flex items-center gap-1.5 text-[0.8125rem] font-semibold text-[color:var(--mkt-accent)] underline-offset-4 hover:underline">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M5 22h14M5 2h14M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2" />
        </svg>
        <span>{{ txt }}</span>
      </a>
    }
  `,
})
export class MktTrialHint {
  private store = inject(PublicTrialStore);
  private chrome = inject(MktChromeText);

  protected text = computed(() => {
    const o = this.store.offer();
    if (!o) return '';
    const main = this.chrome.t('trialHint').replace('{n}', String(o.durationDays));
    return o.requireCard ? main : `${main} · ${this.chrome.t('trialNoCard')}`;
  });

  constructor() {
    this.store.ensureLoaded();
  }
}

/** True when a CMS link goes to sign-up — the hint belongs only next to those. */
export function isSignUpLink(url: string | null | undefined): boolean {
  return (url ?? '').trim().toLowerCase().startsWith('/auth/sign-up');
}
